import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

export default function ForwarderDashboard() {
  const [currentLang, setCurrentLang] = useState(localStorage.getItem('tidjarai_lang') || 'fr');
  const ar = currentLang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const dir = ar ? 'rtl' : 'ltr';
  const [authed, setAuthed] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mode, setMode] = useState('login'); // login | signup
  const [fwd, setFwd] = useState(null);
  const [requests, setRequests] = useState([]);
  const [accessed, setAccessed] = useState({});
  const [responses, setResponses] = useState({});
  const [tab, setTab] = useState('demandes');
  const [replyForm, setReplyForm] = useState({});
  const [fwdMenu, setFwdMenu] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError('');
    const { data, error: authErr } = await supabase.auth.signInWithPassword({ email, password });
    if (authErr) { setError(L('Email ou mot de passe incorrect.','البريد أو كلمة المرور غير صحيحة.')); return; }
    // Check if this email is a registered forwarder
    const { data: fwdData } = await supabase.from('freight_forwarders').select('*').eq('email', email).single();
    if (!fwdData) { setError(L('Ce compte n\'est pas un transitaire. Inscrivez-vous d\'abord.','هذا الحساب ليس وكيل جمارك. سجل أولاً.')); await supabase.auth.signOut(); return; }
    if (!fwdData.is_active) { setError(L('Compte non activé. Contactez l\'administrateur.','الحساب غير مفعّل. اتصل بالمسؤول.')); return; }
    setFwd(fwdData); setAuthed(true); sessionStorage.setItem('fwd_id', fwdData.id);
  };

  const signup = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError(L('Mot de passe : 6 caractères minimum.','كلمة المرور: 6 أحرف على الأقل.')); return; }
    // Check forwarder exists
    const { data: fwdData } = await supabase.from('freight_forwarders').select('*').eq('email', email).single();
    if (!fwdData) { setError(L('Inscrivez-vous d\'abord comme transitaire.','سجل أولاً كوكيل جمارك.')); return; }
    const { error: authErr } = await supabase.auth.signUp({ email, password });
    if (authErr) { setError(authErr.message); return; }
    setError(''); setMode('check_email');
  };

  useEffect(() => {
    const id = sessionStorage.getItem('fwd_id');
    if (id) supabase.from('freight_forwarders').select('*').eq('id', id).single().then(({ data }) => { if (data) { setFwd(data); setAuthed(true); } });
  }, []);

  useEffect(() => {
    if (!fwd) return;
    supabase.from('quote_requests').select('*').eq('status', 'open').order('created_at', { ascending: false }).then(({ data }) => setRequests(data || []));
    supabase.from('forwarder_access_log').select('request_id').eq('forwarder_id', fwd.id).then(({ data }) => {
      const m = {}; (data || []).forEach(d => m[d.request_id] = true); setAccessed(m);
    });
    supabase.from('quote_responses').select('*').eq('forwarder_id', fwd.id).then(({ data }) => {
      const m = {}; (data || []).forEach(d => m[d.request_id] = d); setResponses(m);
    });
  }, [fwd]);

  const accessReq = async (id) => {
    if ((fwd.wallet_balance || 0) < 1000) { alert(L('Solde insuffisant.','الرصيد غير كافٍ.')); return; }
    if (!window.confirm(L('Débloquer cette demande pour 1 000 DZD ?','فتح هذا الطلب مقابل 1,000 د.ج؟'))) return;
    await supabase.from('freight_forwarders').update({ wallet_balance: fwd.wallet_balance - 1000 }).eq('id', fwd.id);
    await supabase.from('forwarder_access_log').insert({ forwarder_id: fwd.id, request_id: id });
    setFwd({ ...fwd, wallet_balance: fwd.wallet_balance - 1000 });
    setAccessed({ ...accessed, [id]: true });
  };

  const sendReply = async (reqId) => {
    const f = replyForm[reqId];
    if (!f?.fee) return;
    await supabase.from('quote_responses').insert({ request_id: reqId, forwarder_id: fwd.id, estimated_fee: f.fee, estimated_delay: f.delay || '', message: f.message || '' });
    setResponses({ ...responses, [reqId]: { estimated_fee: f.fee, estimated_delay: f.delay, message: f.message } });
    setReplyForm({ ...replyForm, [reqId]: null });
  };

  if (!authed) return (
    <div className="app" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh' }} dir={dir}>
      <div className="card" style={{ maxWidth:420, width:'90%' }}>
        <div style={{ textAlign:'center', marginBottom:'1.5rem' }}>
          <div style={{ fontSize:'2.5rem', marginBottom:'0.3rem' }}>🏢</div>
          <h2 style={{ fontSize:'1.2rem' }}>{L('Espace Transitaire','فضاء وكيل الجمارك')}</h2>
          <p style={{ fontSize:'0.82rem', color:'var(--muted)' }}>{mode === 'login' ? L('Connectez-vous à votre compte.','سجل الدخول إلى حسابك.') : mode === 'signup' ? L('Créez votre mot de passe.','أنشئ كلمة المرور.') : ''}</p>
        </div>
        {mode === 'check_email' ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>📧</div>
            <p style={{ fontSize:'0.88rem' }}>{L('Vérifiez votre email pour confirmer votre compte.','تحقق من بريدك لتأكيد حسابك.')}</p>
            <button className="btn btn-outline" style={{ marginTop:'1rem' }} onClick={() => setMode('login')}>{L('Retour à la connexion','العودة لتسجيل الدخول')}</button>
          </div>
        ) : (
          <form onSubmit={mode === 'login' ? login : signup}>
            <div className="form-group"><label>Email</label><input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(''); }} required /></div>
            <div className="form-group"><label>{L('Mot de passe','كلمة المرور')}</label><input type="password" value={password} onChange={e => { setPassword(e.target.value); setError(''); }} required minLength={6} /></div>
            {error && <div style={{ color:'#ef4444', fontSize:'0.8rem', marginBottom:'0.5rem' }}>{error}</div>}
            <button type="submit" className="btn btn-primary" style={{ width:'100%' }}>{mode === 'login' ? L('Se connecter','تسجيل الدخول') : L('Créer mon compte','إنشاء حسابي')}</button>
            <div style={{ textAlign:'center', marginTop:'0.8rem', fontSize:'0.82rem' }}>
              {mode === 'login' ? (
                <button type="button" onClick={() => setMode('signup')} style={{ background:'none', border:'none', color:'#818cf8', cursor:'pointer' }}>{L('Première connexion ? Créer un mot de passe →','أول اتصال؟ أنشئ كلمة مرور →')}</button>
              ) : (
                <button type="button" onClick={() => setMode('login')} style={{ background:'none', border:'none', color:'#818cf8', cursor:'pointer' }}>{L('← Déjà un compte ? Se connecter','← لديك حساب؟ سجل الدخول')}</button>
              )}
            </div>
          </form>
        )}
        <div style={{ textAlign:'center', marginTop:'1rem', fontSize:'0.82rem' }}>
          <a href="/transitaire/inscription" style={{ color:'var(--muted)' }}>{L('Pas encore inscrit ? S\'inscrire →','لم تسجل بعد؟ سجل →')}</a>
        </div>
        <div style={{ textAlign:'center', marginTop:'0.5rem' }}><a href="/" style={{ color:'var(--muted)', fontSize:'0.78rem' }}>← TidjarAI</a></div>
      </div>
    </div>
  );

  return (
    <div className="app" dir={dir}>
      <nav className="navbar">
        <button className="menu-toggle" onClick={() => setFwdMenu(!fwdMenu)}>☰</button>
        <div className="nav-brand" style={{ cursor:'pointer' }} onClick={() => setTab('profil')}>
          <div className="logo">🏢</div><h1 style={{ fontSize:'0.9rem' }}>{fwd.company_name}</h1>
        </div>
        <div className={`nav-tabs${fwdMenu ? ' open' : ''}`}>
          {[{id:'demandes',l:L('Demandes','الطلبات')},{id:'historique',l:L('Mes réponses','ردودي')},{id:'wallet',l:L('Wallet','المحفظة')},{id:'profil',l:L('Profil','الملف')}].map(t =>
            <button key={t.id} className={`nav-tab ${tab===t.id?'active':''}`} onClick={()=>{setTab(t.id);setFwdMenu(false);}}>{t.l}</button>
          )}
        </div>
        <div className="nav-actions">
          <span style={{ fontSize:'0.82rem', color:'#34d399', fontWeight:700 }}>{(fwd.wallet_balance||0).toLocaleString()} DZD</span>
          <button className="nav-btn" onClick={() => { const nl = ar ? 'fr' : 'ar'; setCurrentLang(nl); localStorage.setItem('tidjarai_lang', nl); }}>{ar ? 'FR' : 'عربي'}</button>
          <button className="nav-btn" onClick={() => { supabase.auth.signOut().catch(()=>{}); sessionStorage.removeItem('fwd_id'); window.location.reload(); }}>{L('Déconnexion','خروج')}</button>
        </div>
      </nav>

      <div style={{ maxWidth:900, margin:'1.5rem auto', padding:'0 1rem' }}>

        {/* DEMANDES */}
        {tab === 'demandes' && (<>
          <h3 style={{ marginBottom:'1rem' }}>📋 {L('Demandes disponibles','الطلبات المتاحة')} ({requests.length})</h3>
          {requests.length === 0 && <div className="card" style={{ textAlign:'center', padding:'3rem', color:'var(--muted)' }}><div style={{fontSize:'2rem',marginBottom:'0.5rem'}}>📭</div>{L('Aucune demande pour le moment.','لا توجد طلبات حالياً.')}</div>}
          {requests.map(r => (
            <div key={r.id} className="card" style={{ marginBottom:'0.8rem' }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'0.5rem', flexWrap:'wrap', gap:'0.3rem' }}>
                <h4 style={{ fontSize:'0.95rem' }}>{r.product_description}</h4>
                <span style={{ fontSize:'0.72rem', color:'var(--muted)' }}>{new Date(r.created_at).toLocaleDateString('fr-FR')}</span>
              </div>
              <div style={{ display:'flex', gap:'0.3rem', flexWrap:'wrap', marginBottom:'0.6rem' }}>
                {r.hs_code && <span className="badge badge-blue">{r.hs_code}</span>}
                <span className="badge badge-green">{r.origin_country} → {r.destination_port}</span>
                {r.estimated_value_usd && <span className="badge badge-yellow">~${r.estimated_value_usd}</span>}
                {r.estimated_weight_kg && <span className="badge badge-yellow">~{r.estimated_weight_kg}kg</span>}
                {r.incoterm && <span className="badge badge-blue">{r.incoterm}</span>}
              </div>
              {r.special_requirements && <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:'0.6rem', padding:'0.5rem', background:'rgba(255,255,255,0.02)', borderRadius:8 }}>💡 {r.special_requirements}</p>}

              {/* NOT ACCESSED */}
              {!accessed[r.id] && (
                <button className="btn btn-primary" style={{ width:'100%' }} onClick={() => accessReq(r.id)}>
                  🔓 {L(`Débloquer cette demande — 1 000 DZD (solde: ${(fwd.wallet_balance||0).toLocaleString()})`,`فتح هذا الطلب — 1,000 د.ج (الرصيد: ${(fwd.wallet_balance||0).toLocaleString()})`)}
                </button>
              )}

              {/* ACCESSED — show reply form or sent response */}
              {accessed[r.id] && !responses[r.id] && (
                <div style={{ background:'rgba(124,58,237,0.06)', border:'1px solid rgba(124,58,237,0.15)', borderRadius:12, padding:'1rem', marginTop:'0.5rem' }}>
                  <h4 style={{ fontSize:'0.88rem', marginBottom:'0.6rem', color:'#818cf8' }}>✅ {L('Accès débloqué','تم فتح الوصول')}</h4>
                  {/* Contact info */}
                  <div style={{ background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.15)', borderRadius:10, padding:'0.7rem', marginBottom:'0.8rem' }}>
                    <div style={{ fontSize:'0.78rem', fontWeight:600, color:'#34d399', marginBottom:'0.3rem' }}>📞 {L('Coordonnées du demandeur','بيانات الاتصال بالطالب')}</div>
                    <div style={{ fontSize:'0.85rem' }}>📧 {r.requester_email || '—'}</div>
                    <div style={{ fontSize:'0.85rem' }}>📱 {r.requester_phone || '—'}</div>
                  </div>
                  {/* Reply form */}
                  <h4 style={{ fontSize:'0.82rem', marginBottom:'0.5rem' }}>{L('Envoyez votre offre :','أرسل عرضك:')}</h4>
                  <div className="form-group"><label>{L('Honoraires estimés','الأتعاب المقدرة')} *</label><input placeholder={L('Ex: 35 000 — 45 000 DZD TTC','مثال: 35,000 — 45,000 د.ج')} value={replyForm[r.id]?.fee||''} onChange={e => setReplyForm({...replyForm,[r.id]:{...replyForm[r.id],fee:e.target.value}})} /></div>
                  <div className="form-row">
                    <div className="form-group"><label>{L('Délai estimé','المدة المقدرة')}</label><input placeholder={L('Ex: 5-7 jours ouvrables','مثال: 5-7 أيام عمل')} value={replyForm[r.id]?.delay||''} onChange={e => setReplyForm({...replyForm,[r.id]:{...replyForm[r.id],delay:e.target.value}})} /></div>
                    <div className="form-group"><label>{L('Services inclus','الخدمات المشمولة')}</label><input placeholder={L('Ex: dédouanement, transport, stockage','مثال: تخليص جمركي، نقل، تخزين')} value={replyForm[r.id]?.services||''} onChange={e => setReplyForm({...replyForm,[r.id]:{...replyForm[r.id],services:e.target.value}})} /></div>
                  </div>
                  <div className="form-group"><label>{L('Message détaillé','رسالة مفصلة')}</label><textarea placeholder={L('Décrivez votre offre en détail : conditions, inclusions, exclusions...','صف عرضك بالتفصيل: الشروط، ما هو مشمول، ما هو مستثنى...')} value={replyForm[r.id]?.message||''} onChange={e => setReplyForm({...replyForm,[r.id]:{...replyForm[r.id],message:e.target.value}})} style={{ width:'100%', minHeight:80, padding:'0.6rem', border:'1px solid var(--border)', borderRadius:10, background:'rgba(255,255,255,0.03)', color:'var(--text)', fontFamily:'inherit', resize:'vertical' }} /></div>
                  <button className="btn btn-primary" style={{ width:'100%' }} onClick={() => sendReply(r.id)}>📨 {L('Envoyer mon offre','إرسال عرضي')}</button>
                </div>
              )}

              {/* RESPONSE SENT */}
              {responses[r.id] && (
                <div style={{ background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.2)', borderRadius:12, padding:'1rem', marginTop:'0.5rem' }}>
                  <strong style={{ color:'#34d399' }}>✅ {L('Offre envoyée','تم إرسال العرض')}</strong>
                  <div style={{ fontSize:'0.85rem', marginTop:'0.3rem' }}>{L('Honoraires','الأتعاب')} : <strong>{responses[r.id].estimated_fee}</strong></div>
                  {responses[r.id].estimated_delay && <div style={{ fontSize:'0.82rem', color:'var(--muted)' }}>{L('Délai','المدة')} : {responses[r.id].estimated_delay}</div>}
                </div>
              )}
            </div>
          ))}
        </>)}

        {/* HISTORIQUE RÉPONSES */}
        {tab === 'historique' && (<>
          <h3 style={{ marginBottom:'1rem' }}>📨 {L('Mes réponses envoyées','ردودي المرسلة')}</h3>
          {Object.keys(responses).length === 0 && <div className="card" style={{ textAlign:'center', padding:'2rem', color:'var(--muted)' }}>{L('Aucune réponse envoyée.','لم يتم إرسال أي رد.')}</div>}
          {Object.entries(responses).map(([reqId, resp]) => {
            const req = requests.find(r => r.id === reqId);
            return (
              <div key={reqId} className="card" style={{ marginBottom:'0.8rem' }}>
                <h4 style={{ fontSize:'0.9rem', marginBottom:'0.3rem' }}>{req?.product_description || reqId}</h4>
                <div style={{ fontSize:'0.85rem' }}>{L('Honoraires','الأتعاب')} : <strong style={{ color:'#34d399' }}>{resp.estimated_fee}</strong></div>
                {resp.estimated_delay && <div style={{ fontSize:'0.82rem', color:'var(--muted)' }}>{L('Délai','المدة')} : {resp.estimated_delay}</div>}
                {resp.message && <div style={{ fontSize:'0.82rem', color:'var(--muted)', marginTop:'0.2rem' }}>💬 {resp.message}</div>}
              </div>
            );
          })}
        </>)}

        {/* WALLET */}
        {tab === 'wallet' && (
          <div className="card" style={{ textAlign:'center', padding:'2rem' }}>
            <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>{L('Solde actuel','الرصيد الحالي')}</div>
            <div style={{ fontSize:'2.5rem', fontWeight:900, color:'#7C3AED', margin:'0.5rem 0' }}>{(fwd.wallet_balance||0).toLocaleString()} DZD</div>
            <div style={{ fontSize:'0.85rem', color:'var(--muted)', marginBottom:'1.5rem' }}>{L(`= ${Math.floor((fwd.wallet_balance||0)/1000)} accès demandes`,`= ${Math.floor((fwd.wallet_balance||0)/1000)} وصول إلى الطلبات`)}</div>
            <div className="alert alert-info" style={{ textAlign: ar ? 'right' : 'left' }}>
              <span>💳</span>
              <div>
                <strong>{L('Recharger votre wallet','شحن محفظتك')}</strong><br/>
                {L('Contactez l\'administrateur TidjarAI pour créditer votre compte.','اتصل بمسؤول TidjarAI لشحن حسابك.')}<br/>
                <span style={{ fontSize:'0.78rem', color:'var(--muted)' }}>{L('1 accès = 1 000 DZD','1 وصول = 1,000 د.ج')}</span>
              </div>
            </div>
          </div>
        )}

        {/* PROFIL */}
        {tab === 'profil' && (
          <div className="card">
            <div className="card-title">👤 {L('Mon profil','ملفي')}</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', fontSize:'0.88rem' }}>
              {[
                [L('Société','الشركة'), fwd.company_name],
                [L('Contact','جهة الاتصال'), fwd.contact_name],
                ['Email', fwd.email],
                [L('Téléphone','الهاتف'), fwd.phone],
                [L('Wilaya','الولاية'), fwd.wilaya],
                [L('Ports','الموانئ'), (fwd.ports_covered||[]).join(', ')],
                [L('Spécialités','التخصصات'), (fwd.product_specialties||[]).join(', ')],
                [L('Statut','الحالة'), fwd.is_active ? '✅ '+L('Actif','نشط') : '⏳ '+L('En attente','قيد الانتظار')],
              ].map(([label, val], i) => (
                <div key={i}><span style={{ color:'var(--muted)', fontSize:'0.72rem' }}>{label}</span><br/><strong>{val || '—'}</strong></div>
              ))}
            </div>
            <button className="btn btn-outline" style={{ marginTop:'1rem' }} onClick={() => {
              const phone = prompt(L('Nouveau téléphone :','الهاتف الجديد:'), fwd.phone);
              if (phone) { supabase.from('freight_forwarders').update({ phone }).eq('id', fwd.id).then(() => setFwd({...fwd, phone})); }
            }}>✏️ {L('Modifier téléphone','تعديل الهاتف')}</button>
          </div>
        )}
      </div>
    </div>
  );
}
